import React from 'react';
import Tools from '../../../Misc/Tools';
import { CoreDebugButtonType } from './core-controlled/debug/core-debug-dropdown-window';

import "./core-general-button3.css"

/* 
EXAMPLE
<div style={{
				width: '300px',
				height: '100px'
			}} className="center-element">
				<CoreGeneralButton3 type={GeneralButton3Type.twoDbackward} onClick={() => {
					alert('clicked')
				}} onRenderContent={() => {
					return <p className='default-text'>Some Content</p>
				}}></CoreGeneralButton3>
			</div> */

const CoreGeneralButton3 = (props: GeneralButton3Config) => {
	return (
		<div className="core-general-button3" tabIndex={0} aria-label={props.ariaLabel} style={{
			width: '100%',
			height: '100%',
			pointerEvents: props.isDisabled ? 'none' : 'all',
			...props.style
		}} onKeyUp={Tools.mapDivEnterToClick} onClick={props.onClick}>
			<button style={{backgroundColor: 'black'}} className={"core-general-button3-single-button core-general-button3-" + props.type}>
				<span className=''>{props.onRenderContent()}</span>
			</button>
		</div>
	);

};

export interface GeneralButton3Config {
	type: GeneralButton3Type;
	onClick: () => void;
	onRenderContent: () => any;
	ariaLabel?: string;
	style?: any;
	isSelected?: boolean;
	isDisabled?: boolean;
}

export enum GeneralButton3Type {
	twoDGrow = '2d-grow',
	twoDShrink = '2d-shrink',
	twoDPulse = '2d-pulse',
	twoDPulseGrow = '2d-pulse-grow',
	twoDPulseShrink = '2d-pulse-shrink',
	twoDPush = '2d-push',
	twoDPop = '2d-pop',
	twoDBounceIn = '2d-bounce-in',
	twoDBounceOut = '2d-bounce-out',
	twoDRotate = '2d-rotate',
	twoDGrowRotate = '2d-grow-rotate',
	twoDFloat = '2d-float',
	twoDSink = '2d-sink',
	twoDBob = '2d-bob',
	twoDHang = '2d-hang',
	twoDSkew = '2d-skew',
	twoDSkewForward = '2d-skew-forward',
	twoDSkewBackward = '2d-skew-backward',
	twoDWobbleHorizontal = '2d-wobble-horizontal',
	twoDWobbleVertical = '2d-wobble-vertical',
	twoDWobbleToBottomRight = '2d-wobble-to-bottom-right',
	twoDWobbleToTopRight = '2d-wobble-to-top-right',
	twoDWobbleTop = '2d-wobble-top',
	twoDWobbleBottom = '2d-wobble-bottom',
	twoDWobbleSkew = '2d-wobble-skew',
	twoDBuzz = '2d-buzz',
	twoDBuzzOut = '2d-buzz-out',
	twoDForward = '2d-forward',
	twoDbackward = '2d-backward'
}

export default CoreGeneralButton3;

export const AllButton3Types: CoreDebugButtonType<GeneralButton3Type>[] = [
	{
		key: GeneralButton3Type.twoDGrow,
		value: 'GeneralButton3Type.twoDGrow'
	},
	{
		key: GeneralButton3Type.twoDShrink,
		value: 'GeneralButton3Type.twoDShrink'
	},
	{
		key: GeneralButton3Type.twoDPulse,
		value: 'GeneralButton3Type.twoDPulse'
	},
	{
		key: GeneralButton3Type.twoDPulseGrow,
		value: 'GeneralButton3Type.twoDPulseGrow'
	},
	{
		key: GeneralButton3Type.twoDPulseShrink,
		value: 'GeneralButton3Type.twoDPulseShrink'
	},
	{
		key: GeneralButton3Type.twoDPush,
		value: 'GeneralButton3Type.twoDPush'
	},
	{
		key: GeneralButton3Type.twoDPop,
		value: 'GeneralButton3Type.twoDPop'
	},
	{
		key: GeneralButton3Type.twoDBounceIn,
		value: 'GeneralButton3Type.twoDBounceIn'
	},
	{
		key: GeneralButton3Type.twoDBounceOut,
		value: 'GeneralButton3Type.twoDBounceOut'
	},
	{
		key: GeneralButton3Type.twoDRotate,
		value: 'GeneralButton3Type.twoDRotate'
	},
	{
		key: GeneralButton3Type.twoDGrowRotate,
		value: 'GeneralButton3Type.twoDGrowRotate'
	},
	{
		key: GeneralButton3Type.twoDFloat,
		value: 'GeneralButton3Type.twoDFloat'
	},
	{
		key: GeneralButton3Type.twoDSink,
		value: 'GeneralButton3Type.twoDSink'
	},
	{
		key: GeneralButton3Type.twoDBob,
		value: 'GeneralButton3Type.twoDBob'
	},
	{
		key: GeneralButton3Type.twoDHang,
		value: 'GeneralButton3Type.twoDHang'
	},
	{
		key: GeneralButton3Type.twoDSkew,
		value: 'GeneralButton3Type.twoDSkew'
	},
	{
		key: GeneralButton3Type.twoDSkewForward,
		value: 'GeneralButton3Type.twoDSkewForward'
	},
	{
		key: GeneralButton3Type.twoDSkewBackward,
		value: 'GeneralButton3Type.twoDSkewBackward'
	},
	{
		key: GeneralButton3Type.twoDWobbleHorizontal,
		value: 'GeneralButton3Type.twoDWobbleHorizontal'
	},
	{
		key: GeneralButton3Type.twoDWobbleVertical,
		value: 'GeneralButton3Type.twoDWobbleVertical'
	},
	{
		key: GeneralButton3Type.twoDWobbleToBottomRight,
		value: 'GeneralButton3Type.twoDWobbleToBottomRight'
	},
	{
		key: GeneralButton3Type.twoDWobbleToTopRight,
		value: 'GeneralButton3Type.twoDWobbleToTopRight'
	},
	{
		key: GeneralButton3Type.twoDWobbleTop,
		value: 'GeneralButton3Type.twoDWobbleTop'
	},
	{
		key: GeneralButton3Type.twoDWobbleBottom,
		value: 'GeneralButton3Type.twoDWobbleBottom'
	},
	{
		key: GeneralButton3Type.twoDWobbleSkew,
		value: 'GeneralButton3Type.twoDWobbleSkew'
	},
	{
		key: GeneralButton3Type.twoDBuzz,
		value: 'GeneralButton3Type.twoDBuzz'
	},
	{
		key: GeneralButton3Type.twoDBuzzOut,
		value: 'GeneralButton3Type.twoDBuzzOut'
	},
	{
		key: GeneralButton3Type.twoDForward,
		value: 'GeneralButton3Type.twoDForward'
	},
	{
		key: GeneralButton3Type.twoDbackward,
		value: 'GeneralButton3Type.twoDbackward'
	}
]
